import { NgModule } from '@angular/core';
import { BaiduMap } from './components/map';
var BaiduMapModule = (function () {
    function BaiduMapModule() {
    }
    return BaiduMapModule;
}());
export { BaiduMapModule };
BaiduMapModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    BaiduMap
                ],
                exports: [
                    BaiduMap
                ]
            },] },
];
/** @nocollapse */
BaiduMapModule.ctorParameters = function () { return []; };
export { ControlAnchor } from './enum/ControlAnchor';
export * from './enum/NavigationControlType';
export { MapStatus } from './enum/MapStatus';



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._angular2-baidu-map@3.0.2@angular2-baidu-map/dist/index.js
// module id = ../../../../._angular2-baidu-map@3.0.2@angular2-baidu-map/dist/index.js
// module chunks = 5